import React from 'react';
import { FiPlus, FiTrash2 } from 'react-icons/fi';
import { Field, TextInput, TextArea, ButtonGroup, TogglePill } from '../lib/FormControls';
import { APPLICATION_TYPE_OPTIONS, GENDER_OPTIONS, initialChild } from '../lib/fieldDefs';

export default function Step9ChildrenRiders({ form, setField, setForm, updateChild }) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between rounded-lg border border-gray-200 p-4">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Children</h2>
          <p className="text-sm text-gray-500">Include children on this application?</p>
        </div>
        <TogglePill
          enabled={form.has_children}
          onToggle={() => setField('has_children', !form.has_children)}
        />
      </div>

      {form.has_children && (
        <>
          <button
            type="button"
            onClick={() =>
              setForm((prev) => ({
                ...prev,
                children: [...prev.children, { ...initialChild }],
              }))
            }
            className="inline-flex items-center gap-1 rounded-md border border-primary px-3 py-2 text-sm font-medium text-primary hover:bg-primary/5"
          >
            <FiPlus className="h-4 w-4" />
            Add Child
          </button>

          <div className="space-y-4">
            {form.children.map((child, index) => (
              <div key={`child-${index}`} className="rounded-lg border border-gray-200 p-4">
                <div className="mb-3 flex items-center justify-between">
                  <h3 className="text-sm font-semibold text-gray-700">Child #{index + 1}</h3>
                  <button
                    type="button"
                    onClick={() =>
                      setForm((prev) => ({
                        ...prev,
                        children: prev.children.filter((_, i) => i !== index),
                      }))
                    }
                    className="inline-flex items-center gap-1 text-xs font-medium text-red-600 hover:underline"
                  >
                    <FiTrash2 className="h-3.5 w-3.5" />
                    Remove
                  </button>
                </div>
                <div className="mb-4">
                  <Field label="Application Type" required>
                    <ButtonGroup
                      options={APPLICATION_TYPE_OPTIONS.map((o) => o.label)}
                      value={
                        APPLICATION_TYPE_OPTIONS.find((o) => o.value === child.application_type)
                          ?.label || ''
                      }
                      onChange={(label) => {
                        const match = APPLICATION_TYPE_OPTIONS.find((o) => o.label === label);
                        updateChild(index, 'application_type', match?.value || '');
                      }}
                    />
                  </Field>
                </div>
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <Field label="Full Name" required>
                    <TextInput
                      value={child.full_name}
                      onChange={(e) => updateChild(index, 'full_name', e.target.value)}
                    />
                  </Field>
                  <Field label="DOB" required>
                    <TextInput
                      type="date"
                      value={child.dob}
                      onChange={(e) => updateChild(index, 'dob', e.target.value)}
                    />
                  </Field>
                  <Field label="Gender">
                    <ButtonGroup
                      options={GENDER_OPTIONS}
                      value={child.gender}
                      onChange={(v) => updateChild(index, 'gender', v)}
                    />
                  </Field>
                  <Field label="SSN/ITIN (Optional)" sensitive>
                      <TextInput
                      value={child.ssn}
                      onChange={(e) => updateChild(index, 'ssn', e.target.value)}
                    />
                  </Field>
                  <Field label="Height">
                    <TextInput
                      value={child.height}
                      onChange={(e) => updateChild(index, 'height', e.target.value)}
                    />
                  </Field>
                  <Field label="Weight">
                    <TextInput
                      value={child.weight}
                      onChange={(e) => updateChild(index, 'weight', e.target.value)}
                    />
                  </Field>
                </div>
                <div className="mt-3 grid grid-cols-1 gap-4">
                  <Field label="Known Conditions">
                    <TextArea
                      rows={3}
                      value={child.known_conditions}
                      onChange={(e) => updateChild(index, 'known_conditions', e.target.value)}
                    />
                  </Field>
                  <Field label="Medications">
                    <TextArea
                      rows={3}
                      value={child.medications}
                      onChange={(e) => updateChild(index, 'medications', e.target.value)}
                    />
                  </Field>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
